import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
var InputTooltip = function (_a) {
    var text = _a.text, icon = _a.icon, children = _a.children;
    var tooltipRef = useRef(null);
    var containerRef = useRef(null);
    var _b = useState(''), positionClass = _b[0], setPositionClass = _b[1];
    var _c = useState('bottom'), verticalPosition = _c[0], setVerticalPosition = _c[1];
    var handlePosition = function () {
        requestAnimationFrame(function () {
            var parentContainer = document.getElementById('containerId');
            var tooltip = tooltipRef.current;
            var container = containerRef.current;
            if (!tooltip || !container || !parentContainer)
                return;
            var parentRect = parentContainer.getBoundingClientRect();
            var rect = tooltip.getBoundingClientRect();
            var containerRect = container.getBoundingClientRect();
            // Vertical position
            var spaceBelow = parentRect.bottom - containerRect.bottom;
            if (spaceBelow < rect.height) {
                setVerticalPosition('top');
            }
            else {
                setVerticalPosition('bottom');
            }
            // Horizontal position
            var iconCenter = containerRect.left + containerRect.width / 2;
            var spaceRight = parentRect.width - iconCenter - 16;
            var spaceLeft = iconCenter - 16;
            var horizontalClass = '';
            if (spaceLeft < rect.width / 2 && spaceRight < rect.width / 2) {
                horizontalClass = 'left-1/2 -translate-x-1/2';
            }
            else if (spaceRight < rect.width / 2) {
                horizontalClass = 'right-0 translate-x-4';
            }
            else if (spaceLeft < rect.width / 2) {
                horizontalClass = 'left-0 translate-x-4';
            }
            setPositionClass(horizontalClass);
        });
    };
    var handleMouseLeave = function () {
        setPositionClass('');
    };
    // Render either custom children or formatted text
    var renderContent = function () {
        if (children)
            return children;
        if (text) {
            return (React.createElement("div", { className: "bg-white border border-gray-200 rounded-lg p-[8px] w-[244px] overflow-y-auto shadow-lg" }, Array.isArray(text) ? (text.map(function (line, index) { return (React.createElement("p", { key: index, className: "text-xs py-1" }, line
                .split(/(\*\*.*?\*\*)/g)
                .map(function (part, i) {
                return part.startsWith('**') && part.endsWith('**') ? (React.createElement("strong", { key: i }, part.slice(2, -2))) : (part);
            }))); })) : (React.createElement("span", { className: "text-xs block" }, text))));
        }
        return null;
    };
    return (React.createElement("div", { className: "flex items-center justify-center relative size-[18px] group ml-2", ref: containerRef, onMouseEnter: handlePosition, onMouseLeave: handleMouseLeave, onClick: handlePosition }, icon !== null && icon !== void 0 ? icon : (React.createElement(FontAwesomeIcon, { icon: faLightbulb, size: "sm", color: "#252846", className: "transition-transform duration-200 cursor-pointer group-hover:scale-110 group-hover:text-yellow-500" })),
        React.createElement("div", { ref: tooltipRef, style: { minWidth: '244px' }, className: "absolute ".concat(verticalPosition === 'bottom'
                ? 'top-full pt-[8px]'
                : 'bottom-full pb-[8px]', " opacity-0 hidden visible group-hover:opacity-100 group-hover:block z-[40] transition-all duration-200 ").concat(positionClass) }, renderContent())));
};
export default InputTooltip;
